<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
* {
  margin: 0;
  padding: 0;
  font-size: 30px;
}
.van-dialog {
  width: 500px !important;
}
.van-dialog .van-dialog__header {
  font-size: 36px !important;
}
.van-dialog .van-dialog__content .van-dialog__message {
  font-size: 32px !important;
  /* height: 100px; */
  line-height: 50px;
  padding-top: 20 px;
}
.van-dialog .van-dialog__footer .van-button {
  font-size: 35px !important;
  height: 90px;
}
.van-toast {
  line-height: normal !important;
  font-size: 28px !important;
  width: 200px !important;
}
.van-cell {
  font-size: 30px !important;
}
.van-cell__title {
  font-weight: 600 !important;
  color: #000 !important;
}
.van-field__control::placeholder {
  color: #000;
}
.van-button--normal {
  font-size: 30px;
  height: 60px;
}
.van-cell--required:before {
  font-size: 30px;
}
.van-picker__cancel,
.van-picker__confirm {
  font-size: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue